export default "/dist/files/icon_journaux_gris.2618836081e037d31cb3fbc8a928e013.svg";